import merge from 'lodash/fp/merge';

/**
 * @param {Object} initialState
 * @param {function} [additionalReducer]
 * @return {function} - reducer
 */
export default (initialState, additionalReducer) =>
    (state = initialState, action) => {
        if (action.payload && action.payload.entities) {
            return merge(state, action.payload.entities);
        }

        if (additionalReducer) {
            return additionalReducer(state, action);
        }

        return state;
    };
